export default __webpack_public_path__ + "static/media/1407.830acdcb.png";